<template>
  <div class="no-data">
    <img class="noCustomImg" src="https://bigdata.topeti.com/PCRepository/mainPlatform/Intersect.png" alt="">
    <div class="noCustomTextTwo">{{ text }}</div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'noData',
  // 组件参数 接收来自父组件的数据
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
}
</script>

<style scoped lang="scss">
.no-data {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .noCustomImg {
    margin: 0 auto;
    display: inline-block;
    width: 106px;
    height: 99px;
  }

  .noCustomTextTwo {
    margin: 16px auto 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 16px;
    opacity: 0.45;
  }
}
</style>
